import { accorder } from '../plural.js';
export const es = {
    langue: {
        selecteur: 'Idioma',
    },
    coquille: {
        sautContenu: 'Ir al contenido',
        deconnexion: 'Cerrar sesión',
        versionInconnue: 'desconocida',
        version: (version, horodatage) => `Versión ${version} — compilación del ${horodatage}`,
        signature: '— Repère, organización y tranquilidad',
    },
    compte: {
        menu: 'Menú',
        monCompte: 'Mi cuenta',
        options: 'Opciones',
        aide: 'Ayuda',
        mesDossiers: 'Mis expedientes',
        nouveauDossier: 'Nuevo expediente',
        identiteTitre: 'Su cuenta',
        formule: 'Plan',
        situation: 'Situación',
        debut: 'Desde el',
        echeance: 'Hasta el',
        origine: 'Origen',
        origines: {
            stripe: 'Suscripción pagada',
            code_essai: 'Código de prueba',
            geste: 'Gesto comercial',
        },
        statuts: {
            none: 'Sin suscripción',
            trialing: 'Prueba en curso',
            active: 'Activa',
            past_due: 'Pago pendiente',
            canceled: 'Cancelada',
        },
        resiliationProgrammee: 'Su suscripción terminará al final del periodo en curso.',
        essaiJusquau: (date) => `Prueba gratuita hasta el ${date}.`,
        accesCouvert: 'Su acceso de escritura está abierto gracias al plan Duo contratado en un expediente ' +
            'que comparte. Puede contratar su propia suscripción cuando quiera.',
        accesProfessionnel: 'Escribe en virtud de un acceso profesional abierto por un progenitor, no de una suscripción.',
        factures: 'Mis facturas y mi pago',
        ouvertureFactures: 'Abriendo…',
        facturesIndisponibles: 'Sin facturas: su acceso no procede de un pago con tarjeta.',
        erreurFactures: 'No se ha podido abrir la página de facturación',
        dossiersTitre: 'Sus expedientes',
        parent: (rang) => `Progenitor ${rang}`,
        placeLibre: 'Plaza todavía libre',
        aucunDossier: 'Todavía no tiene ningún expediente.',
        optionsTitre: 'Opciones',
        retourPrecedent: 'Volver',
        apparence: 'Apariencia',
        apparenceAide: '«Automático» sigue el ajuste de su dispositivo: se oscurece por la noche sin que tenga que pensarlo.',
        langueTitre: 'Idioma',
        langueAide: 'El idioma de la aplicación y de sus correos.',
        lectureIA: 'Lectura de justificantes',
        lectureIAAide: 'Cuando adjunta la foto de un ticket a un gasto, Repère puede leerla y proponerle el ' +
            'importe, la fecha y la categoría. La foto se envía a Mistral, nuestro proveedor ' +
            'europeo de IA, solo con ese fin, y no se conserva allí. Es el único dato de su ' +
            'expediente que sale de nuestros servidores.',
        lectureIAActive: 'Leer mis justificantes',
        lectureIAInactive: 'No enviar nada, lo escribo yo',
        notificationsTitre: 'Notificaciones',
        silenceAide: 'Durante estas horas su teléfono permanece en silencio. Nada se pierde: se guarda ' +
            'y se entrega todo junto al terminar el silencio.',
        silenceActive: 'Dejarme tranquilo por la noche',
        silenceDesactive: 'Avisarme a cualquier hora',
        silenceDebut: 'Desde',
        silenceFin: 'Hasta',
        silenceNote: (fin) => `Lo que llegue durante el silencio se le entregará a las ${fin}, en un solo ` +
            'mensaje. Una alerta urgente sí pasa.',
        silenceNoteInactif: 'Se le avisa en cuanto ocurre algo, a cualquier hora.',
        emailTitre: 'Correos',
        emailAide: 'Este ajuste solo afecta a su buzón. Las notificaciones en su teléfono no cambian.',
        emailImmediat: 'Un correo cada vez',
        emailQuotidien: 'Un único resumen al día',
        emailImmediatNote: 'Recibe un correo en cuanto ocurre algo, salvo durante sus horas de silencio.',
        emailQuotidienNote: (heure) => `Un solo correo al día, a las ${heure}, con el recuento de lo ocurrido. Su teléfono ` +
            'sigue avisándole al instante. Una alerta urgente lo ignora y se envía de inmediato.',
        emailHeure: 'Resumen enviado a las',
        conges: 'Vacaciones escolares',
        congesAide: 'De dónde saca tu calendario las fechas de vacaciones. El calendario oficial cubre la ' +
            'Francia metropolitana; un archivo .ics toma el relevo para ultramar, una escuela en el ' +
            'extranjero o un centro que fija sus propias fechas.',
        congesPartage: 'Esta elección es del expediente: el otro progenitor ve el mismo calendario.',
        congesOfficiel: 'Calendario oficial',
        congesOfficielZone: (zone) => `Zona ${zone}, deducida del código postal de la escuela.`,
        congesOfficielSansZone: 'Ninguna zona deducida: indica el código postal de la escuela en la ficha del niño, o sube un archivo.',
        congesFichier: 'Archivo subido',
        congesFichierAide: 'Un archivo .ics exportado de la agenda de la escuela. Se lee al llegar y no se conserva: ' +
            'solo sus fechas.',
        congesDeposer: 'Elegir un archivo .ics',
        congesDepotEnCours: 'Leyendo el archivo…',
        congesDepot: (nom, periodes) => `${nom} · ${periodes} periodo${periodes > 1 ? 's' : ''}`,
        congesCouverture: (debut, fin) => `Del ${debut} al ${fin}.`,
        congesRetirer: 'Quitar este archivo',
        congesErreur: 'No se ha podido leer este archivo',
        congesAucunDossier: 'Todavía no tienes ningún expediente que configurar.',
        congesMemes: 'Vacaciones de los niños',
        congesMemesOui: 'Las mismas para todos',
        congesMemesNon: 'Un ajuste por niño',
        congesMemesAide: 'Un colegio y un instituto a ambos lados de un límite de academia bastan para separar a ' +
            'los hermanos. Cada niño parte entonces del calendario oficial de SU escuela, y el ' +
            'calendario enmarca sus días con su color.',
        congesEnfant: (prenom) => `Vacaciones de ${prenom}`,
    },
    dates: {
        mois: [
            'enero',
            'febrero',
            'marzo',
            'abril',
            'mayo',
            'junio',
            'julio',
            'agosto',
            'septiembre',
            'octubre',
            'noviembre',
            'diciembre',
        ],
        jour: 'Día',
        moisLabel: 'Mes',
        annee: 'Año',
    },
    creerDossier: {
        titre: 'Crear un expediente',
        etapeSur4: (etape) => `Paso ${etape} de 4`,
        erreurEtape: 'Este paso no se ha completado',
        jalon: { enfants: 'Hijos', garde: 'Custodia', invitation: 'Invitación', pret: 'Listo' },
        etatJalon: { termine: 'completado', enCours: 'en curso', aVenir: 'pendiente' },
        etape1: {
            titreCarte: 'Sus hijos',
            aideFratrie: 'Un expediente reúne a los hijos que tiene con un mismo otro progenitor. Para añadir un hermano o una hermana a un expediente existente, ábralo y vaya a «Hijos».',
            prenom: 'Nombre',
            dateNaissance: 'Fecha de nacimiento',
            suffixeRang: (index) => ` del hijo/a ${index + 1}`,
            enfantParDefaut: (index) => `Hijo/a ${index + 1}`,
            retirer: 'Quitar',
            retirerSuffixe: (index, prenom) => ` al hijo/a ${index + 1}${prenom ? `, ${prenom}` : ''}`,
            ajouter: 'Añadir otro hijo/a',
            continuer: 'Continuar',
        },
        etape2: {
            titreCarte: 'El régimen de custodia',
            aideModification: 'Podrá modificarlo más adelante — cualquier cambio requerirá el acuerdo del otro progenitor.',
            schema: 'Régimen',
            nidation: 'En modalidad de anidamiento (nesting)',
            nidationAide: 'El hijo/a permanece en el domicilio familiar y son los progenitores quienes se turnan. El reparto del tiempo sigue siendo el del régimen elegido.',
            dateDebut: 'Fecha de inicio',
            heure: 'Hora del cambio de custodia',
            heureAide: 'A menudo, la salida del colegio.',
            quiCommence: 'Quién empieza',
            moi: 'Yo',
            autreParent: 'El otro progenitor',
            revenir: 'Volver',
            creer: 'Crear el expediente',
            creationEnCours: 'Creando…',
        },
        etape3: {
            titreCarte: 'Invitar al otro progenitor',
            intro: 'Repère protege a ambos progenitores por igual: el otro progenitor tendrá exactamente los mismos derechos que usted sobre este expediente, y ninguno de los dos puede quitarle nada al otro.',
            redaction: 'El mensaje lo redacta Repère, en un tono neutro. No tiene que escribir nada.',
            email: 'Correo electrónico del otro progenitor',
            plusTard: 'Más tarde',
            envoyer: 'Enviar la invitación',
            envoiEnCours: 'Enviando…',
        },
        etape4: {
            titreCarte: 'Su expediente está listo',
            messageAvecInvitation: 'La invitación se ha enviado. El expediente ya se puede usar, sin esperar respuesta.',
            messageSansInvitation: 'El expediente ya se puede usar. Podrá invitar al otro progenitor cuando lo desee.',
            ouvrir: 'Abrir el expediente',
        },
        residence: {
            pays: 'País de residencia del hijo/a',
            ville: 'Ciudad de residencia del hijo/a',
            zone: (zone) => `Zona de vacaciones escolares ${zone}.`,
            zoneInconnue: 'Zona no reconocida — la ortografía exacta del municipio ayuda a encontrarla.',
        },
    },
    entree: {
        presentation: {
            accrocheCourte: 'El calendario de custodia, los mensajes y los documentos de sus hijos, todo en un mismo lugar.',
            accrocheLongue: 'Repère es la herramienta de los padres separados: el calendario de custodia, los mensajes y los documentos de sus hijos, todo en un mismo lugar.',
            publics: 'Está pensada para ambos progenitores, cualquiera que sea el régimen de custodia y cualquiera que sea el estado de su relación. Un abogado, mediador o trabajador social puede ser invitado en modo lectura, si uno de ustedes lo decide.',
            garanties: 'Todo queda fechado por nuestros servidores, y nada puede modificarse ni eliminarse después — ni usted, ni el otro progenitor, ni nuestro equipo. Cada uno dispone exactamente de los mismos derechos y ve exactamente lo mismo.',
        },
        modesAcces: {
            titre: '¿Ha recibido una invitación?',
            autreParentTitre: 'Usted es el otro progenitor',
            autreParentTexte: 'Unirse al expediente es gratis: el registro y el calendario no requieren ninguna suscripción. Cada uno puede suscribirse después si lo desea — 9,90 € al mes — y ninguno puede cortar el acceso del otro.',
            proTitre: 'Usted es abogado, mediador o trabajador social',
            proTexte: 'Su cuenta es gratuita, sin límite de expedientes. Accede en modo lectura a lo que un progenitor le comparta, durante el tiempo que este decida. El otro progenitor es informado de su llegada: nadie entra en un expediente sin que alguien lo sepa.',
        },
        fournisseurs: {
            indisponible: 'Próximamente',
            separateurOu: 'o',
            intro: 'Con una cuenta que ya tiene — sin una contraseña nueva que recordar.',
            redirection: (nom) => `Redirigiendo a ${nom}…`,
            verbeAvec: (verbe, nom) => `${verbe} con ${nom}`,
            indisponibleDetail: 'Próximamente. El correo electrónico y la contraseña dan acceso a todo el producto: ninguna función dependerá jamás de una cuenta externa.',
        },
        feuille: {
            fermer: 'Cerrar',
        },
        connexion: {
            titre: 'Iniciar sesión',
            verbe: 'Iniciar sesión',
            pasDeCompte: '¿Todavía no tiene una cuenta?',
            sInscrire: 'Registrarse',
            email: 'Correo electrónico',
            motDePasse: 'Contraseña',
            motDePasseOublie: '¿Olvidó su contraseña?',
            connexionEnCours: 'Iniciando sesión…',
            erreurTitre: 'No se pudo iniciar sesión',
            echecRefus: 'La conexión se interrumpió. Puede intentarlo de nuevo, o introducir su correo y su contraseña.',
            echecExpire: 'La conexión tardó demasiado. Vuelva a intentarlo.',
            echecGenerique: 'La conexión con este proveedor no se completó. Puede introducir su correo y su contraseña en su lugar.',
        },
        inscription: {
            titre: 'Crear una cuenta',
            verbe: 'Registrarse',
            motDePasseTropCourt: 'La contraseña debe tener al menos 12 caracteres.',
            verifiezBoite: 'Revise su correo',
            siAdresseUtilisable: 'Si esta dirección puede utilizarse, se le acaba de enviar un mensaje. Abra el enlace que contiene para confirmar su dirección.',
            dejaConnexionPossible: 'Ya puede iniciar sesión: la confirmación puede esperar.',
            dejaCompte: '¿Ya tiene una cuenta?',
            seConnecter: 'Iniciar sesión',
            prenom: 'Nombre',
            prenomAide: 'Se muestra al otro progenitor.',
            email: 'Correo electrónico',
            motDePasse: 'Contraseña',
            motDePasseAide: 'Al menos 12 caracteres. Una frase que recuerde hace una buena contraseña.',
            erreurTitre: 'No se pudo crear la cuenta',
            creationEnCours: 'Creando…',
            creerMonCompte: 'Crear mi cuenta',
            echecGenerique: 'Algo no ha funcionado. Inténtelo de nuevo en un momento.',
        },
    },
    dossier: {
        categories: {
            aujourdhui: 'Hoy',
            calendrier: 'Calendario',
            messages: 'Mensajes',
            depenses: 'Gastos',
            journal: 'Diario',
            enfants: 'Hijos',
        },
        navigation: {
            ariaCategories: 'Categorías del expediente',
            reserveParent: 'Reservado a los planes Solo y Duo. Lo ya guardado sigue siendo legible.',
            reserveParentSuffixe: ', reservado a los planes Solo y Duo',
            nouveaute: (n) => accorder('es', n, { one: '1 novedad', other: `${n} novedades` }),
        },
        calendrier: {
            moisPrecedent: 'Mes anterior',
            moisSuivant: 'Mes siguiente',
            erreurChargement: 'No se ha podido cargar el calendario',
            titre: (moisEtAnnee) => `Calendario de custodia — ${moisEtAnnee}`,
            chezVous: 'Con usted',
            chezAutre: (nom) => `Con ${nom}`,
            nonDefini: 'sin definir',
            libelleEchange: 'intercambio de días',
            libelleDerogation: 'excepción acordada',
            titreEchange: 'Intercambio de días acordado',
            titreDerogationConvenue: 'Excepción acordada',
            avecMotif: (base, motif) => `${base} — ${motif}`,
            suffixeDerogation: (libelle) => `, ${libelle}`,
            suffixeMotif: (motif) => `, motivo: ${motif}`,
            marqueEchange: 'Intercambiado',
            legendeEchange: 'Día intercambiado de mutuo acuerdo',
            suffixeConge: ' — vacaciones escolares',
            suffixeCongeEnfants: (prenoms) => ` — vacaciones escolares: ${prenoms}`,
            legendeConge: (zone) => `Vacaciones escolares · zona ${zone}`,
            legendeCongeFichier: 'Vacaciones escolares · archivo subido',
            legendeCongeEnfant: (prenom, source) => `${prenom} — ${source}`,
            legendeCongesAbsents: 'Vacaciones escolares: nada que mostrar. Indica el código postal de la escuela en la ' +
                'ficha del niño, o sube un archivo de vacaciones desde Mi cuenta › Opciones.',
        },
        journal: {
            ariaFiltrer: 'Filtrar el diario',
            filtreTout: 'Todas',
            filtrePartagees: 'Compartidas',
            filtrePrivees: 'Privadas',
            entreeSuffixe: (n) => accorder('es', n, { one: ', 1 entrada', other: `, ${n} entradas` }),
            erreurChargement: 'No se ha podido cargar el diario',
            modeSoloTexte: 'Por ahora está solo en este expediente, y el diario funciona con normalidad. Si el otro progenitor se une más adelante, verá las entradas que haya marcado como compartidas, con su fecha original.',
            videTout: 'Todavía no hay entradas.',
            videPartagees: 'No hay entradas compartidas.',
            videPrivees: 'No hay entradas privadas.',
            auteurVous: 'Usted',
            auteurAutreParent: 'El otro progenitor',
            marquePrivee: 'Privada',
            marquePartagee: 'Compartida',
            invisibleSuffixePrivee: 'Entrada privada, visible solo para usted, inalterable.',
            invisibleSuffixePartagee: 'Entrada compartida con el otro progenitor, inalterable.',
            mentionImmuable: 'Cada entrada queda fechada por nuestros servidores y ya no puede modificarse ni eliminarse — ni por usted, ni por el otro progenitor, ni por nuestro equipo. Anote hechos: lo que ocurrió, cuándo.',
            mentionImmuableBouton: 'Inmutabilidad del diario',
            labelFait: 'El hecho a anotar',
            placeholderFait: 'El hecho a anotar — «Cambio realizado a las 18:05»',
            ariaQuiPeutVoir: '¿Quién puede ver esta entrada?',
            intituleVisiblePar: 'Visible para',
            visibiliteAutre: 'El otro progenitor',
            visibiliteAutreAide: 'Aparece de forma idéntica en el diario de ambos progenitores.',
            visibiliteMoi: 'Solo usted',
            visibiliteMoiAide: 'El otro progenitor no es informado. Solo aparecerá en su propia exportación.',
            aideChoixDefaut: 'Elija quién verá esta entrada: nada está marcado de antemano.',
            enregistrementEnCours: 'Guardando…',
            consigner: 'Anotar',
            erreurEnregistrement: 'No se ha podido guardar la entrada',
            reformuler: 'Reformula este texto por mí',
            reformulationEnCours: 'Reformulando…',
            reformulationTitre: 'Otra forma de decirlo',
            reformulationAide: 'No se guarda nada: ni su borrador, ni esta propuesta — nadie sabrá que la ha pedido.',
            reformulationUtiliser: 'Usar esta versión',
            reformulationGarder: 'Mantener mi texto',
            reformulationDejaNeutre: 'Su texto ya es factual: no hay nada que suavizar.',
            reformulationIndisponible: 'La reformulación no está disponible ahora mismo. Puede anotar su texto tal cual.',
            reformulationBudget: 'Ha usado sus reformulaciones de hoy. Vuelven mañana.',
            reformulationTropLong: 'Este texto es demasiado largo para reformularlo.',
        },
        depenses: {
            statutAttente: 'Esperando respuesta',
            statutAcceptee: 'Aceptada',
            statutContestee: 'Impugnada',
            statutRemboursee: 'Reembolsada',
            categories: ['salud', 'escolaridad', 'comedor', 'actividades', 'ropa', 'transporte'],
            comptesAJour: 'Las cuentas están al día.',
            soldePhrase: (debiteur, jeSuisDebiteur, montant, crediteur) => `${debiteur} ${jeSuisDebiteur ? 'debe' : 'debe'} ${montant} a ${crediteur}.`,
            detailLigneALigne: 'El detalle, línea por línea',
            ligneDetail: (date, categorie, montant, payeur, montantAutre) => `${date} — ${categorie}: ${montant} adelantados por ${payeur}, de los cuales ${montantAutre} corren a cargo del otro.`,
            soldeNonStocke: 'Este saldo no se almacena en ningún sitio: se recalcula en cada visualización a partir de estas líneas. Puede rehacer usted mismo la suma.',
            sansRegleTitre: 'Algunos gastos esperan una clave de reparto',
            sansRegleTexte: (n) => accorder('es', n, {
                one: '1 gasto es anterior a cualquier clave y no se contabiliza.',
                other: `${n} gastos son anteriores a cualquier clave y no se contabilizan.`,
            }),
            erreurChargement: 'No se han podido cargar los gastos',
            declarerUneDepense: 'Declarar un gasto',
            justificatifAnalyse: 'Analizado, cifrado y adjuntado a los documentos del expediente.',
            lectureTitre: '¿Leer el justificante por usted?',
            lectureQuestion: 'Repère puede leer la foto de su ticket y proponerle el importe, la fecha y la ' +
                'categoría. Usted lo revisa, lo corrige y lo valida.',
            lectureDetail: 'La foto se envía a Mistral, nuestro proveedor europeo de IA, solo con ese fin. No ' +
                'se conserva allí, y nosotros tampoco guardamos nada. Es el único dato de su ' +
                'expediente que sale de nuestros servidores: puede retirar este consentimiento en ' +
                'cualquier momento en «Opciones».',
            lectureAccepter: 'Sí, leer mis justificantes',
            lectureRefuser: 'No, lo escribo yo',
            lectureEnCours: 'Leyendo el justificante…',
            lectureProposee: 'Importe, fecha, categoría y comentario propuestos según el justificante. Revíselos.',
            commentaire: 'Comentario',
            commentairePlaceholder: 'Farmacia del Centro — antibióticos y apósitos',
            commentaireAide: 'Opcional. Lo que dice el justificante: el comercio, lo que se compró. La lectura del ' +
                'justificante puede proponerlo; usted lo revisa.',
            lectureRien: 'No se ha podido leer nada en esta foto. Introduzca el gasto a mano.',
            lectureIndisponible: 'La lectura no está disponible ahora mismo. Introduzca el gasto a mano.',
            lectureBudget: 'Ha usado sus lecturas de hoy. Vuelven mañana.',
            lectureQuota: 'Este expediente ha usado sus cinco lecturas de hoy. Vuelven mañana.',
            retirer: 'Quitar',
            photographierLeTicket: 'Fotografiar el recibo',
            choisirUnFichier: 'Elegir un archivo',
            envoiEnCours: 'Enviando…',
            justificatifAide: 'Opcional, pero es lo que decide si el gasto se impugna. PDF o foto.',
            erreurJustificatif: 'No se ha podido adjuntar el justificante',
            montant: 'Importe',
            montantInvalide: 'Importe no válido.',
            dateDeLaDepense: 'Fecha del gasto',
            ariaCategorie: 'Categoría del gasto',
            erreurDeclaration: 'No se ha podido guardar el gasto',
            enregistrementEnCours: 'Guardando…',
            declarerLaDepense: 'Declarar el gasto',
            aideAvecCategorie: 'La fecha elegida determina la clave de reparto aplicada.',
            aideSansCategorie: 'Elija una categoría: nada está preseleccionado.',
            unParent: 'Un progenitor',
            vous: 'Usted',
            justificatifJoint: 'Justificante adjunto',
            avancePar: (date, payeur) => `${date} · adelantado por ${payeur}`,
            accepter: 'Aceptar',
            motifSiConteste: 'Motivo, si lo impugna',
            motifAide: 'Un desacuerdo sin motivo no lleva a ningún sitio: diga cuál es el problema.',
            contester: 'Impugnar',
            videListe: 'Todavía no hay gastos.',
            ongletDetail: 'Detalle',
            ongletPartagees: 'Gastos compartidos',
        },
        messagerie: {
            ariaFils: 'Hilos de conversación',
            filTous: 'Todos',
            filSansFil: 'Sin hilo',
            filSante: 'Salud',
            filEcole: 'Colegio',
            filVacances: 'Vacaciones',
            filUrgences: 'Emergencias',
            messageSuffixe: (n) => accorder('es', n, { one: ', 1 mensaje', other: `, ${n} mensajes` }),
            erreurChargement: 'No se han podido cargar los mensajes',
            ouvrirLaPieceJointe: 'Abrir el archivo adjunto',
            erreurOuverturePiece: 'No se ha podido abrir el archivo adjunto',
            pieceJointeScellee: 'Sellado con el mensaje: sustituirlo rompería su huella.',
            redactionPieceScellee: (nomFichier) => `${nomFichier} — analizado, cifrado, y su huella sellada con el mensaje: sustituirlo después rompería la cadena.`,
            videAucun: 'Todavía no hay mensajes.',
            videAucunDansCeFil: 'No hay mensajes en este hilo.',
            nouveauxMessages: (n) => accorder('es', n, { one: '1 mensaje nuevo', other: `${n} mensajes nuevos` }),
            vosEnvoisDifferes: 'Sus envíos programados',
            envoisDifferesAide: 'Visibles solo para usted mientras no se hayan enviado. Todavía puede cancelarlos.',
            envoiPrevu: (corps, date, heureTexte) => `«${corps}» — envío previsto el ${date} a las ${heureTexte}`,
            annulerCetEnvoi: 'Cancelar este envío',
            retirer: 'Quitar',
            mentionImmuable: 'Los mensajes intercambiados aquí no pueden modificarse ni eliminarse — ni por usted, ni por el otro progenitor, ni por nuestro equipo. Cada uno queda fechado por nuestros servidores.',
            mentionImmuableBouton: 'Inmutabilidad de los mensajes',
            reformuler: 'Reformula este mensaje por mí',
            reformulationEnCours: 'Reformulando…',
            reformulationTitre: 'Otra forma de decirlo',
            reformulationAide: 'No se ha enviado nada y no se guarda nada: ni su borrador, ni esta propuesta. ' +
                'El otro progenitor no sabrá que la ha pedido.',
            reformulationUtiliser: 'Usar esta versión',
            reformulationGarder: 'Mantener mi texto',
            reformulationDejaNeutre: 'Su mensaje ya es factual: no hay nada que suavizar.',
            reformulationIndisponible: 'La reformulación no está disponible ahora mismo. Su mensaje sale sin cambios.',
            reformulationBudget: 'Ha usado sus reformulaciones de hoy. Vuelven mañana.',
            reformulationTropLong: 'Este mensaje es demasiado largo para reformularlo.',
            votreMessage: 'Su mensaje',
            placeholderEcrire: 'Escribir un mensaje…',
            joindreUnDocument: 'Adjuntar un documento',
            envoyerPlusTard: 'Enviar más tarde',
            envoiEnCours: 'Enviando…',
            programmerLEnvoi: 'Programar el envío',
            envoyer: 'Enviar',
            dateEtHeureEnvoi: 'Fecha y hora de envío',
            aideHorodatage: 'El sello de tiempo que hará fe será el del envío efectivo.',
            erreurEnvoi: 'No se ha podido enviar el mensaje',
            inactiveTexte: 'La mensajería se activará cuando el otro progenitor se una al expediente: no tiene sentido sin interlocutor.',
            auteurVous: 'Usted',
            auteurAutreParent: 'El otro progenitor',
            messageInvisible: (date, heureTexte, numero) => `${date} a las ${heureTexte}. Mensaje número ${numero}, inalterable.`,
        },
        suppression: {
            ouvrir: 'Eliminar este expediente',
            titre: 'Eliminar este expediente',
            texte: 'La eliminación se decide entre los dos: el otro progenitor recibirá un mensaje y ' +
                'deberá validarla. Una vez validada, el expediente sigue consultable durante treinta ' +
                'días sin poder modificarse y después se destruye definitivamente. Durante ese ' +
                'plazo, cualquiera de los dos puede anularlo todo.',
            texteSolo: 'Está solo en este expediente: el mensaje de validación se le enviará a usted. Una ' +
                'vez validada, la eliminación deja el expediente consultable durante treinta días ' +
                'sin poder modificarse y después se destruye definitivamente. Puede anularlo todo ' +
                'hasta el último día.',
            demander: 'Solicitar la eliminación',
            envoiEnCours: 'Enviando…',
            erreur: 'No se ha podido enviar la solicitud',
            renoncer: 'No eliminar',
            attenteAutre: 'Se ha solicitado la eliminación de este expediente. El otro progenitor ha recibido ' +
                'un mensaje: solo surtirá efecto si la valida.',
            attenteVous: 'Se ha solicitado la eliminación de este expediente. Ha recibido un mensaje: ábralo ' +
                'para validarla o rechazarla.',
            attenteEcheance: (date) => `Sin respuesta, esta solicitud se anulará sola el ${date}.`,
            archiveTitre: 'Expediente archivado',
            archiveTexte: (date) => `Este expediente se destruirá definitivamente el ${date}.`,
            archiveLecture: 'Hasta entonces sigue consultable — puede releerlo y pedir una exportación — pero ' +
                'ya nadie puede escribir en él.',
            annuler: 'Anular la eliminación',
            annulationEnCours: 'Anulando…',
        },
        ecran: {
            modeSolo: `Está utilizando este expediente solo`,
            modePartage: `Expediente compartido · derechos idénticos`,
            modePartageAvec: (prenom) => `Compartido con ${prenom} · derechos idénticos`,
            quiALEnfant: `¿Quién tiene al hijo/a?`,
            quiReponseVous: `El hijo/a está con usted`,
            quiReponseAutre: (prenom) => `El hijo/a está con ${prenom}`,
            quiAucunSchema: `Ningún régimen de custodia cubre esta fecha`,
            quiDerogation: `Por excepción acordada.`,
            quiRecherche: `Consultando…`,
            quiErreur: `No se ha podido obtener la respuesta`,
            quiDateAujourdhui: (date) => `Hoy, ${date}`,
            quiQuelleDate: `¿Qué fecha?`,
            quiAutreJour: `Ver otro día`,
            quiRevenirAujourdhui: `Volver a hoy`,
            demandesAccord: `Solicitudes de acuerdo`,
            ongletNouveautes: `Novedades`,
            ongletDossier: `El expediente`,
            modeSoloTexte: `El calendario, el diario y los documentos funcionan con normalidad. Todo lo que registre a partir de ahora queda fechado.`,
            invitationEnvoyeeTexte: `Se ha enviado una invitación. Sigue siendo válida durante 30 días.`,
            renvoyerOuCorriger: `Reenviar o corregir la dirección`,
            nouvelleAdresseRemplace: `La nueva dirección sustituye a la anterior: el enlace ya enviado deja de ser válido.`,
            peutInviterQuandVeut: `Puede invitar al otro progenitor cuando lo desee.`,
            erreurInvitation: `No se ha podido enviar la invitación`,
            emailAutreParent: `Correo electrónico del otro progenitor`,
            aideInvitation: `El mensaje lo redacta Repère, en un tono neutro.`,
            envoiEnCours: `Enviando…`,
            envoyerInvitation: `Enviar la invitación`,
            calendrierDeGarde: `El calendario de custodia`,
            demanderEchange: `Solicitar un intercambio de días`,
            historiqueSchema: `Historial del régimen de custodia`,
            depensesPartagees: `Gastos compartidos`,
            ficheDe: (prenom) => `Ficha de ${prenom}`,
        },
    },
    schemasDeGarde: {
        schemas: {
            alternating_week: {
                libelle: 'Semana alterna (7/7)',
                detail: 'Una semana con uno, una semana con el otro. El régimen más habitual.',
            },
            two_two_five_five: {
                libelle: '2-2-5-5',
                detail: 'Dos días fijos con cada uno cada semana, luego cinco días incluyendo el fin de semana.',
            },
            two_two_three: {
                libelle: '2-2-3',
                detail: 'Dos noches, dos noches, tres noches: pensado para niños pequeños.',
            },
            three_four_four_three: {
                libelle: '3-4-4-3',
                detail: 'Cambio a mitad de semana, en un ciclo de dos semanas.',
            },
            fortnight: {
                libelle: 'Quincena alterna (14/14)',
                detail: 'Dos semanas con cada uno: adolescentes, o distancia geográfica.',
            },
            nine_five: {
                libelle: 'Alternancia 9/5',
                detail: 'Nueve noches con uno, cinco con el otro, en un ciclo de dos semanas.',
            },
            ten_four: {
                libelle: 'Alternancia 10/4',
                detail: 'Diez noches con uno, cuatro con el otro, en un ciclo de dos semanas.',
            },
            alternate_weekends: {
                libelle: 'Fines de semana alternos (1º, 3º, 5º)',
                detail: 'Régimen de visitas y pernocta clásico: un fin de semana de cada dos, de viernes a domingo.',
            },
            extended_weekends: {
                libelle: 'Fines de semana alternos ampliados',
                detail: 'Régimen de visitas ampliado: un fin de semana de cada dos, del viernes por la tarde al lunes por la mañana.',
            },
            visits_only: {
                libelle: 'Visitas sin pernocta',
                detail: 'Régimen de visitas reducido: solo de día, sin pernocta. Cada visita se anota en el calendario.',
            },
            holidays_only: {
                libelle: 'Solo vacaciones escolares',
                detail: 'Régimen de visitas de larga distancia: sin fines de semana regulares, la mayor parte de las vacaciones.',
            },
            third_party: {
                libelle: 'Residencia con un tercero',
                detail: 'El hijo/a reside con un tercero; el tiempo de cada progenitor se fija individualmente.',
            },
            custom: {
                libelle: 'A medida',
                detail: 'Sin generación automática: el calendario se construye periodo a periodo.',
            },
        },
        familles: {
            alternance: 'Residencia alterna',
            alternance_inegale: 'Residencia alterna desigual',
            residence_principale: 'Residencia principal con un progenitor',
            autre: 'Otro',
        },
    },
    apercu: {
        titre: 'Vista previa de la alternancia',
        pasDeCycle: (libelle) => `«${libelle}» no tiene un ciclo que desplegar: los tiempos de cada uno se fijan periodo a periodo, en el calendario del expediente. Por tanto, no hay nada que previsualizar aquí.`,
        choisirDate: 'Elija una fecha de inicio: la vista previa mostrará entonces los tres primeros meses, día a día.',
        aPartirDu: (date) => `A partir del ${date}:`,
        joursChezVous: (n) => accorder('es', n, { one: '1 día con usted', other: `${n} días con usted` }),
        etJoursChezAutre: (n) => `y ${n} con el otro progenitor, en los tres meses mostrados.`,
        chezVousInvisible: ', con usted',
        chezAutreInvisible: ', con el otro progenitor',
        legendeChezVous: 'Con usted',
        legendeChezAutre: 'Con el otro progenitor',
        legendePassage: 'Cambio de custodia',
    },
    site: {
        nav: {
            accueil: 'Inicio',
            tarifs: 'Precios',
            connexion: 'Iniciar sesión',
            inscription: 'Registrarse',
        },
        footer: {
            accroche: 'Organización y tranquilidad para padres separados. Alojado en Francia, sin rastreadores, sin cookies de terceros.',
            produit: 'Producto',
            tarifsLien: 'Precios',
            applicationsLien: 'Aplicaciones móviles',
            legal: 'Legal',
            mentionsLegales: 'Aviso legal',
            confidentialite: 'Política de privacidad',
            pied: (annee) => `Repère-kids — ${annee}. Alojado en Francia.`,
            version: (version, horodatage) => `Versión ${version} — compilación del ${horodatage}`,
        },
        accueil: {
            titre: 'Coordinación para padres separados',
            description: 'Repère: calendario de custodia, gastos compartidos, mensajería con sello de tiempo e historial inalterable para padres separados.',
            badgeConfiance: 'Alojado en Francia · Sin rastreadores',
            h1: 'La coordinación, sin que cada intercambio se convierta en una negociación.',
            accroche: 'Un calendario de custodia, gastos compartidos, documentos, mensajes — y un registro con sello de tiempo que ningún progenitor puede reescribir.',
            etrePrevenu: 'Recibir aviso del lanzamiento',
            pointChiffre: 'Cifrado por expediente',
            pointServeurs: 'Servidores en Francia',
            pointHistorique: 'Historial inalterable',
            question: '¿Quién tiene a los niños el miércoles?',
            reponseForte: 'Miércoles 16 de septiembre — con usted',
            reponseSuite: 'Próximo cambio: viernes 18, 16:30',
            moisCarte: 'Septiembre de 2026',
            legendeChezVous: 'Con usted',
            legendeChezAutre: 'Con el otro progenitor',
            captureAlt: 'Captura de pantalla de Repère-kids: el calendario de custodia de un expediente compartido, agosto de 2026.',
            captureLegende: 'La aplicación, vista de calendario. Datos ficticios.',
            surTitreChange: 'Lo que Repère cambia',
            titreChange: 'Tres preguntas que ya no hay que discutir',
            introChange: 'El calendario, los acuerdos y el historial — cada uno resuelto una vez por el producto, no por usted.',
            carte1Titre: 'Un calendario que responde al instante',
            carte1Texte: '¿Quién tiene al niño el miércoles? La respuesta está en pantalla, para hoy o para cualquier otra fecha.',
            carte2Titre: 'Acuerdos con fecha',
            carte2Texte: 'Un intercambio de días se propone, se acepta o se rechaza. Cada paso queda registrado, nadie tiene que recordar quién dijo qué.',
            carte3Titre: 'Un historial que no pertenece a nadie',
            carte3Texte: 'Ni usted, ni el otro progenitor, ni nuestro soporte pueden modificar o eliminar lo que se ha compartido.',
            surTitreParti: 'Filosofía',
            titreParti: 'Diseñado para no convertirse nunca en un arma',
            texteParti: 'Repère registra hechos; no los interpreta ni los dramatiza. Ambos progenitores tienen exactamente los mismos derechos — ninguno puede excluir al otro, ni retirar nada del historial común.',
            absencesIntitule: 'Lo que no encontrará aquí',
            absence1: 'Confirmación de lectura',
            absence2: 'Estado "en línea", "visto a las", "última conexión"',
            absence3: 'Contador de retrasos, puntuación de comportamiento',
            absence4: 'Cuenta "propietaria" del expediente',
            surTitreAcces: 'Modalidades de acceso',
            titreAcces: '¿Ha recibido una invitación?',
            introAcces: 'La pregunta surge antes de crear una cuenta, así que la respuesta llega antes del formulario.',
            acces1Titre: 'Usted es el otro progenitor',
            acces1Texte: 'Unirse al expediente es gratis: el registro y el calendario no requieren suscripción. Cada uno se suscribe después si lo desea — 9,90 € al mes — y nadie puede cortar el acceso del otro.',
            acces1Badge: 'Gratis',
            acces2Titre: 'Usted es abogado, mediador o trabajador social',
            acces2Texte: 'Su cuenta es gratuita, sin límite de expedientes. Accede en modo lectura a lo que un progenitor le abre, durante el tiempo que este decida. El otro progenitor es informado de su llegada: nadie entra en un expediente sin conocimiento de los demás.',
            acces2Badge: 'Gratis, ilimitado',
            acces3Titre: 'Está descubriendo el servicio sin haber recibido nada',
            acces3Texte: 'Inscríbase en la lista de espera para recibir un aviso en la apertura. Solo crea un expediente si decide invitar al otro progenitor.',
            acces3Badge: 'Sin cuenta',
            surTitreTarifs: 'Precios',
            titreTarifs: 'Una suscripción por progenitor. Nada más.',
            introTarifs: 'Sin versión "premium" que desbloquee derechos sobre el otro: ambos progenitores ven lo mismo, sea cual sea su suscripción.',
            basculeLegende: 'Frecuencia de facturación',
            basculeMensuel: 'Mensual',
            basculeAnnuel: 'Anual',
            tarifRejoindreTitre: 'Link',
            tarifRejoindrePrix: '0 €',
            tarifRejoindreTexte: 'Para el progenitor invitado a unirse a un expediente existente.',
            tarifRejoindreAvantage1: 'Calendario de custodia compartido',
            tarifRejoindreAvantage2: 'Lectura completa del historial',
            tarifRejoindreAvantage3: 'Sin fecha límite',
            tarifParentTitre: 'Solo',
            tarifParentEtiquette: 'El más habitual',
            tarifParentPrixMensuel: '9,90 € / mes, por progenitor',
            tarifParentPrixMensuelDuo: '14,90 € / mes, para ambos progenitores',
            tarifParentPrixAnnuelSeul: '99 € / año, por progenitor',
            tarifParentPrixAnnuelDuo: '149 € / año, para ambos progenitores',
            tarifParentPrixAnnuel: 'Dos meses gratis respecto al mensual.',
            tarifParentEssaiGratuit: 'Prueba gratuita de 7 días',
            tarifParentBoutonNotification: 'Reservar mi acceso anticipado',
            tarifParentSwitchDuo: 'Incluir al otro progenitor',
            tarifParentEarlybirdEtiquette: 'Reserva anticipada',
            tarifParentEarlybirdTexte: '79 € el primer año para los inscritos en la lista de espera, después tarifa anual.',
            tarifParentEarlybirdTexteDuo: '129 € el primer año para los inscritos en la lista de espera, después tarifa anual.',
            tarifParentEngagement: 'Sin permanencia mensual. Cancelable con un clic desde su cuenta.',
            tarifParentOptionDeuxEtiquette: 'Dúo',
            tarifParentOptionDeuxTexte: '+5 € al mes, 14,90 € en total, para cubrir también la suscripción del otro progenitor.',
            tarifParentOptionDeuxTexteAnnuel: '+50 € al año, 149 € en total, para cubrir también la suscripción del otro progenitor.',
            tarifParentAvantage1: 'Todo lo incluido en Link',
            tarifParentAvantage2: 'Mensajería, gastos compartidos, documentos cifrados',
            tarifParentAvantage3: 'Propuestas de intercambio y diario',
            tarifParentAvantage4: 'Exportación con sello de tiempo del expediente',
            tarifParentAvantage5: 'Invitación de un profesional en modo lectura',
            tarifProTitre: 'Pro',
            tarifProPrix: '0 €',
            tarifProTexte: 'Abogado, mediador familiar, trabajador social.',
            tarifProAvantage1: 'Número ilimitado de expedientes',
            tarifProAvantage2: 'Acceso en lectura, por invitación de un progenitor',
            tarifProAvantage3: 'Exportación de historial autenticada',
            mentionTarifs: 'Precios con impuestos incluidos. El servicio aún no está abierto: las condiciones exactas — duración de la prueba, modalidades de cancelación — se publicarán aquí en la apertura.',
            surTitreMobile: 'En el teléfono',
            titreMobile: 'El calendario en el bolsillo, el historial en el mismo lugar',
            texteMobile: 'Las aplicaciones iOS y Android dan acceso al mismo expediente que la web: los mismos derechos, los mismos datos, el mismo historial. Una notificación le avisa de una propuesta de intercambio o de una alerta urgente — nunca de si el otro progenitor está conectado.',
            appStore: 'App Store',
            googlePlay: 'Google Play',
            mobileNote: 'Los enlaces a App Store y Google Play se activarán cuando se abra el servicio.',
            mobileCalendrierAlt: 'Vista previa de la pantalla de calendario de la aplicación móvil.',
            mobileDossiersAlt: 'Vista previa de la pantalla de inicio de la aplicación móvil: la lista de expedientes.',
            mobileLegende: 'Vistas previas de la aplicación móvil. Datos ficticios.',
        },
        waitlist: {
            titre: 'Recibir aviso del lanzamiento',
            texte: 'Déjenos su dirección: recibirá un mensaje en la apertura, y nada más. Sin boletín, sin recordatorios.',
            labelEmail: 'Dirección de correo electrónico',
            bouton: 'Inscribirme',
            aide: 'Se usa únicamente para avisarle del lanzamiento. Puede eliminarse en cualquier momento.',
            erreurEmailInvalide: 'Por favor, introduzca una dirección de correo electrónico válida.',
            envoiEnCours: 'Enviando…',
            succes: 'Anotado. Recibirá un mensaje en el lanzamiento.',
            echec: 'El registro no se ha completado. Inténtelo de nuevo en unos instantes.',
        },
        confidentialite: {
            titre: 'Política de privacidad',
            description: 'Cómo trata Repère los datos personales: alojamiento en Francia, cifrado, ausencia de rastreadores.',
            avisProvisoire: 'Documento provisional, pendiente de validación jurídica. Describe fielmente el funcionamiento técnico del servicio, pero su redacción legal debe ser revisada por un abogado antes de la apertura (véase la hoja de ruta del proyecto).',
            miseAJour: (date) => `Última actualización: ${date}.`,
            siteTitre: 'Este sitio',
            siteTexte1: 'El sitio no deposita ninguna cookie y no llama a ningún servicio de terceros.',
            siteTexte2: 'Si se inscribe en la lista de espera, solo se conserva su dirección de correo electrónico, junto con la página desde la que se realizó la inscripción. Se usa únicamente para avisarle del lanzamiento, y puede solicitar su eliminación en cualquier momento.',
            serviceTitre: 'El servicio',
            serviceHebergementTitre: 'Alojamiento en Francia',
            serviceHebergementTexte: ', copias de seguridad incluidas. Sin transferencia fuera de la Unión Europea.',
            serviceChiffrementTitre: 'Cifrado',
            serviceChiffrementTexte: ': los intercambios se cifran en tránsito; los contenidos sensibles y los documentos se cifran en reposo, con una clave propia para cada expediente de coparentalidad.',
            serviceBoutTitre: 'Sin cifrado de extremo a extremo',
            serviceBoutTexte: ', y lo decimos con claridad: el servicio debe poder sellar, timbrar y exportar el historial para cumplir su promesa. Sus contenidos pueden ser descifrados por el servicio, nunca por un tercero.',
            serviceHistoriqueTitre: 'Historial común conservado',
            serviceHistoriqueTexte: ': la eliminación de una cuenta anonimiza a su titular pero no destruye el historial compartido, que también pertenece al otro progenitor. Es una característica esencial del servicio, indicada desde el registro.',
            serviceSignatureTitre: 'Prueba independiente',
            serviceSignatureTexte: ': cada entrada se firma digitalmente en el momento de su registro por un tercero independiente, ajeno a Repère — el mismo procedimiento que certifica un documento oficial. La prueba de que nada se ha modificado desde entonces sigue siendo verificable en cualquier momento.',
            servicePubTitre: 'Sin publicidad, sin rastreadores, sin reventa.',
            servicePubTexte: ' Los registros técnicos no contienen datos personales.',
            droitsTitre: 'Sus derechos',
            droitsTexte: 'El acceso, la rectificación, la portabilidad, la supresión, la limitación y la oposición se ejercen ante el servicio. La exportación del expediente también sirve como respuesta al derecho de acceso. Los datos de contacto del delegado de protección de datos se publicarán aquí antes de la apertura del servicio.',
        },
        mentionsLegales: {
            titre: 'Aviso legal',
            description: 'Aviso legal del sitio Repère: editor, alojamiento y propiedad intelectual.',
            avisProvisoire: 'Documento provisional, pendiente de validación jurídica. Los datos de identificación del editor y del alojador se completarán antes de la apertura del servicio.',
            miseAJour: (date) => `Última actualización: ${date}.`,
            editeurTitre: 'Editor',
            editeurTexte: 'Repère — forma jurídica, domicilio social, número de registro y director de la publicación por completar.',
            hebergementTitre: 'Alojamiento',
            hebergementTexte: 'El sitio y el servicio están alojados en Francia. Ningún dato se transfiere fuera de la Unión Europea.',
            contactTitre: 'Contacto',
            contactTexte: 'Dirección de contacto por completar.',
            proprieteTitre: 'Propiedad intelectual',
            proprieteTexte: 'La marca Repère, su logotipo y el contenido de este sitio están protegidos. Queda prohibida cualquier reproducción sin autorización.',
        },
    },
    notifications: {
        libelles: {
            message_new: { un: 'un mensaje nuevo', plusieurs: (n) => `${n} mensajes nuevos` },
            proposal_new: {
                un: 'una nueva solicitud de acuerdo',
                plusieurs: (n) => `${n} nuevas solicitudes de acuerdo`,
            },
            proposal_answered: {
                un: 'una respuesta a una solicitud de acuerdo',
                plusieurs: (n) => `${n} respuestas a solicitudes de acuerdo`,
            },
            expense_new: { un: 'un gasto nuevo', plusieurs: (n) => `${n} gastos nuevos` },
            document_new: { un: 'un documento nuevo', plusieurs: (n) => `${n} documentos nuevos` },
            calendar_event_new: {
                un: 'un elemento nuevo en el calendario',
                plusieurs: (n) => `${n} elementos nuevos en el calendario`,
            },
            alert_new: { un: 'una alerta', plusieurs: (n) => `${n} alertas` },
            professional_invited: {
                un: 'un acceso profesional abierto',
                plusieurs: (n) => `${n} accesos profesionales abiertos`,
            },
            writing_opened: {
                un: 'la escritura abierta en un expediente',
                plusieurs: (n) => `la escritura abierta en ${n} expedientes`,
            },
        },
        enumeration: (morceaux) => morceaux.length <= 1
            ? (morceaux[0] ?? '')
            : `${morceaux.slice(0, -1).join(', ')} y ${morceaux.at(-1)}`,
    },
    mail: {
        verification: {
            objet: 'Confirme su dirección de correo electrónico',
            texte: (lien) => [
                'Hola,',
                '',
                'Para confirmar su dirección de correo electrónico en Repère, abra este enlace:',
                lien,
                '',
                'Este enlace es válido durante 24 horas. Si no ha sido usted quien ha hecho esta solicitud,',
                'puede ignorar este mensaje: no se activará ninguna cuenta.',
                '',
                'Repère — organización y tranquilidad',
            ].join('\n'),
            titre: 'Confirme su dirección de correo electrónico',
            paragraphes: [
                'Hola,',
                'Para confirmar su dirección de correo electrónico en Repère, use el botón de abajo.',
            ],
            bouton: 'Confirmar mi dirección',
            note: 'Este enlace es válido durante 24 horas. Si no ha sido usted quien ha hecho esta solicitud, puede ignorar este mensaje: no se activará ninguna cuenta.',
        },
        invitationDossier: {
            objet: 'Ha sido invitado a unirse a un expediente en Repère',
            texte: (inviterName, lien) => [
                'Hola,',
                '',
                `${inviterName} usa Repère para organizar el día a día de sus hijos`,
                'y le propone unirse al expediente.',
                '',
                'Repère protege a ambos progenitores de la misma manera: tendrá exactamente',
                'los mismos derechos, y el historial no pertenece a ninguno de los dos. Nadie',
                'puede retirar nada de él, ni excluirle.',
                '',
                'Para unirse al expediente:',
                lien,
                '',
                'Este enlace es válido durante 30 días. Si prefiere no usarlo, puede',
                'ignorar este mensaje: no ocurrirá nada.',
                '',
                'Repère — organización y tranquilidad',
            ].join('\n'),
            titre: 'Ha sido invitado a unirse a un expediente',
            paragraphes: (inviterName) => [
                'Hola,',
                `${inviterName} usa Repère para organizar el día a día de sus hijos y le propone unirse al expediente.`,
                'Repère protege a ambos progenitores de la misma manera: tendrá exactamente los mismos derechos, y el historial no pertenece a ninguno de los dos. Nadie puede retirar nada de él, ni excluirle.',
            ],
            bouton: 'Unirme al expediente',
            note: 'Este enlace es válido durante 30 días. Si prefiere no usarlo, puede ignorar este mensaje: no ocurrirá nada.',
        },
        digest: {
            objet: 'Novedades en su expediente Repère',
            texte: (resume, webUrl) => [
                'Hola,',
                '',
                `Su expediente Repère contiene ${resume}.`,
                '',
                'Para consultarlo:',
                webUrl,
                '',
                'Puede ajustar sus horas silenciosas y la frecuencia de estos mensajes',
                'en las preferencias de su cuenta.',
                '',
                'Repère — organización y tranquilidad',
            ].join('\n'),
            titre: 'Novedades en su expediente',
            paragraphes: (resume) => ['Hola,', `Su expediente Repère contiene ${resume}.`],
            bouton: 'Abrir mi expediente',
            note: 'Puede ajustar sus horas silenciosas y la frecuencia de estos mensajes en las preferencias de su cuenta.',
        },
        alerte: {
            objetUrgent: 'Alerta urgente en su expediente Repère',
            objetNormal: 'Alerta en su expediente Repère',
            texte: (motif, webUrl) => [
                'Hola,',
                '',
                `Se ha depositado una alerta en su expediente Repère, con el motivo «${motif}».`,
                '',
                'Para leerla:',
                webUrl,
                '',
                'Repère — organización y tranquilidad',
            ].join('\n'),
            titreUrgent: 'Alerta urgente en su expediente',
            titreNormal: 'Alerta en su expediente',
            paragraphes: ['Hola,', 'Se ha depositado una alerta en su expediente Repère.'],
            encart: (motif) => `Motivo indicado: «${motif}»`,
            bouton: 'Leer la alerta',
        },
        invitationPro: {
            objet: 'Se le ha abierto un acceso profesional en Repère',
            texte: (modules, url) => [
                'Hola,',
                '',
                'Un progenitor le ha abierto un acceso de consulta a su expediente Repère.',
                '',
                `Verá: ${modules}.`,
                '',
                'Este acceso es de solo lectura: no escribe nada, y nada de lo que',
                'consulta se modifica con su paso. Sus consultas quedan inscritas en',
                'el registro del expediente, que ambos progenitores pueden leer.',
                'Cada uno de los dos progenitores puede ponerle fin en cualquier momento.',
                '',
                'Es gratuito y sin compromiso. Para encontrarlo:',
                url,
                '',
                'Repère — organización y tranquilidad',
            ].join('\n'),
            titre: 'Se le ha abierto un acceso profesional',
            paragraphes: (modules) => [
                'Hola,',
                'Un progenitor le ha abierto un acceso de consulta a su expediente Repère.',
                `Verá: ${modules}.`,
                'Este acceso es de solo lectura: no escribe nada, y nada de lo que consulta se modifica con su paso. Sus consultas quedan inscritas en el registro del expediente, que ambos progenitores pueden leer. Cada uno de los dos progenitores puede ponerle fin en cualquier momento.',
                'Es gratuito y sin compromiso.',
            ],
            bouton: 'Abrir mi acceso',
        },
        lienPaiement: {
            objet: 'Su enlace para suscribirse a Repère',
            texte: (lien) => [
                'Hola:',
                '',
                'Acaba de solicitar suscribirse desde la aplicación Repère.',
                'Abra este enlace para terminar, en este dispositivo o en otro:',
                lien,
                '',
                'Este enlace es válido durante 1 hora. Después, vuelva a solicitarlo desde la aplicación.',
                'No se le cobra nada mientras no lo confirme.',
                '',
                '— Repère',
            ].join('\n'),
            titre: 'Terminar su suscripción',
            paragraphes: [
                'Acaba de solicitar suscribirse desde la aplicación. El pago se termina aquí, en este dispositivo o en otro.',
                'No se le cobra nada mientras no lo confirme.',
            ],
            bouton: 'Terminar el pago',
            note: 'Este enlace es válido durante 1 hora. Después, vuelva a solicitarlo desde la aplicación.',
        },
        reinitialisation: {
            objet: 'Restablecimiento de su contraseña',
            texte: (lien) => [
                'Hola,',
                '',
                'Ha solicitado restablecer su contraseña de Repère. Abra este enlace:',
                lien,
                '',
                'Este enlace es válido durante 1 hora y solo funciona una vez.',
                'Si no ha sido usted quien ha hecho esta solicitud, ignore este mensaje:',
                'su contraseña actual sigue siendo válida.',
                '',
                'Repère — organización y tranquilidad',
            ].join('\n'),
            titre: 'Restablecimiento de su contraseña',
            paragraphes: ['Hola,', 'Ha solicitado restablecer su contraseña de Repère.'],
            bouton: 'Restablecer mi contraseña',
            note: 'Este enlace es válido durante 1 hora y solo funciona una vez. Si no ha sido usted quien ha hecho esta solicitud, ignore este mensaje: su contraseña actual sigue siendo válida.',
        },
        suppressionDossier: {
            objet: 'Una eliminación de expediente espera su validación',
            texte: (demandeur, lien) => [
                'Hola:',
                '',
                demandeur
                    ? `${demandeur} ha solicitado la eliminación de un expediente de Repère que comparten.`
                    : 'Ha solicitado la eliminación de uno de sus expedientes de Repère.',
                '',
                'De momento no se ha eliminado nada. La eliminación se valida desde este enlace:',
                lien,
                '',
                'Una vez validada, el expediente sigue consultable durante treinta días sin poder',
                'modificarse y después se destruye definitivamente. Durante ese plazo puede',
                'anularse en cualquier momento, por cualquiera de los dos.',
                '',
                'Este enlace es válido 7 días. Sin respuesta, la solicitud se anula sola y el',
                'expediente queda intacto.',
                '',
                'Repère — organización y serenidad',
            ].join('\n'),
            titre: 'Una eliminación de expediente espera su validación',
            paragraphes: (demandeur) => [
                'Hola:',
                demandeur
                    ? `${demandeur} ha solicitado la eliminación de un expediente de Repère que comparten.`
                    : 'Ha solicitado la eliminación de uno de sus expedientes de Repère.',
                'De momento no se ha eliminado nada. Una vez validada, el expediente sigue consultable durante treinta días sin poder modificarse y después se destruye definitivamente. Durante ese plazo puede anularse en cualquier momento, por cualquiera de los dos.',
            ],
            bouton: 'Abrir la solicitud',
            note: 'Este enlace es válido 7 días. Sin respuesta, la solicitud se anula sola y el expediente queda intacto.',
        },
    },
    mobile: {
        notifications: {
            verification: 'Notificaciones: comprobando…',
            pretes: 'Notificaciones listas en este dispositivo.',
            refusees: 'Ha rechazado las notificaciones. Puede volver a activarlas en los ajustes del teléfono.',
            indisponiblesTitre: 'Notificaciones no disponibles',
            appareilRattacheTitre: 'Dispositivo registrado',
            appareilActif: 'Este dispositivo está registrado. Recibirá avisos incluso con la aplicación cerrada.',
            appareilInactif: 'Ha iniciado sesión, pero este dispositivo aún no puede recibir avisos.',
        },
        dossiers: {
            titre: 'Sus expedientes',
            chargement: 'Cargando…',
            erreur: 'No se han podido cargar sus expedientes.',
            aucun: 'Todavía no hay ningún expediente. Puede crear uno desde la aplicación web.',
            deconnexion: 'Cerrar sesión',
            ouvrirIndice: 'Abre el calendario de este expediente',
        },
        calendrier: {
            retour: 'Volver',
            aujourdHui: 'Hoy',
            jusqua: (heure) => `Hasta las ${heure}`,
        },
    },
};
//# sourceMappingURL=es.js.map